import React, { useState } from "react";
import { Star, Quote, MapPin } from "lucide-react";

interface Review {
  id: number;
  name: string;
  rating: number;
  time: string;
  quote: string;
  avatar: string;
}

const GIZ_REVIEWS: Review[] = [
  {
    id: 1,
    name: "Fauziah Rachmawati",
    rating: 4,
    time: "6 bulan lalu",
    quote:
      "GIZ menggabungkan unsur edukasi tentang satwa dan teknologi digital modern. Cocok untuk anak-anak, remaja, dan siapa saja yang ingin merasakan petualangan virtual satwa tanpa hewan nyata, sekaligus berburu foto kekinian.",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjXq1Xu4z2LFyJjsITXQMO_uWCutEwnj52TIN3kXSmZy8OiHHPAquw=w36-h36-p-rp-mo-ba6-br100",
  },
  {
    id: 2,
    name: "Tasya Thalia",
    rating: 5,
    time: "setahun lalu",
    quote:
      "Keren banget tempatnyaa, semua spotnya instagramable, puas bgt pokoknya dengan harga yg terjangkau bisa merasakan Glow Interactive Zoo kaya gini 😍",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjUJL32S_djMeneohnk3O-8acehGOTmaAqsJNofvcb9XL8FP9xnt=w36-h36-p-rp-mo-br100",
  },
  {
    id: 3,
    name: "Mayang Putri",
    rating: 5,
    time: "setahun lalu",
    quote:
      "Bagus tempat nya kids frndly utk anak2, spot untuk foto jadi keren semua😍",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjXN4uKmiRHi2OWsBDWMEHBhbFbIBR-Es4Uw_3w8xHZuR9S7Pg=w36-h36-p-rp-mo-br100",
  },
  {
    id: 4,
    name: "Dimas Dwilaksono",
    rating: 5,
    time: "setahun lalu",
    quote:
      "Salah satu tempat yang harus dikunjungi kalo lagi liburan ke Surabaya. Wahana yang sangat edukatif cocok sebagai salah satu pilihan tempat wisata untuk menikmati quality time bersama keluarga.",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjWbbI8aXkl2mMxI9o3LZ595AoyRLMpQP75feUV-ah4x7ImJwG2E=w36-h36-p-rp-mo-br100",
  },
  {
    id: 5,
    name: "Oneway",
    rating: 5,
    time: "setahun lalu",
    quote:
      "Makin keren aja ini KBS ada Wahana Baru GIZ Park. Murah tiket e, dompet ga jebol ngajak jalan keluarga 😍😍",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjUqdkXs9f6LTm9y-bsMQsxZYxawww79IB1HoqUpP5nEBP4MQl9H8w=w36-h36-p-rp-mo-ba2-br100",
  },
  {
    id: 6,
    name: "Arman Maulantaaa",
    rating: 5,
    time: "setahun lalu",
    quote:
      "Keren banget tempatnya.. bawa anak dan mertua semua happy, anak saya gk mau pulang karna senengnya.. anakku nangis gk mau pulang dia suka banget ama tempatnya.. istriku juga gk mau pulang 😄",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjW7pzf8g3Eagrx60NSzxED_TeAViYyZif4IzzhpjWR7l29jpzaJ=w36-h36-p-rp-mo-br100",
  },
];

const RIW_REVIEWS: Review[] = [
  {
    id: 1,
    name: "Ayla Teomi",
    rating: 5,
    time: "4 bulan lalu",
    quote:
      "Bagus banget tempatnya 😍😍😍 cocok banget untuk edukasi anak-anak, kelincinya lucu-lucu... viewnya juga indah banget. Gak nyesel lah kalo ngajak anak-anak liburan kesini.",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjUsuvVtDpLJnw7nyNo42fZiuJuW1E0ykL-VhXcEmnK62KQMWJU=w36-h36-p-rp-mo-br100",
  },
  {
    id: 2,
    name: "Vivan Nur Alfian",
    rating: 5,
    time: "3 bulan lalu",
    quote:
      "Sangat lucu dan membuat siapapun yg masuk disini jadi mood bagus... tempat unik kreatif dan kelincinya banyak.",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjUqZF5j4hsBzfDnvDxGaKavZXt4oKxh1lqAysrPSpb-3unU7x-K=w36-h36-p-rp-mo-ba3-br100",
  },
  {
    id: 3,
    name: "Elsa Ermalia",
    rating: 5,
    time: "4 bulan lalu",
    quote:
      "Di Surabaya Zoo liburan jadi makin asik, ada wahana baru Wonderland bisa jumpa kelinci-kelinci kesukaan anak saya. Tempatnya juga enak luas dan para petugasnya ramah.",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjU6vBFEDbf8TVSEWxDPQPN7q3CObCU_kpUqh0zJ5s9KL39l2grx=w36-h36-p-rp-mo-br100",
  },
  {
    id: 4,
    name: "Rizky Rizaldy",
    rating: 5,
    time: "4 bulan lalu",
    quote:
      "Kemarin sempet kesitu, tempatnya baguss bgtt beda dari yg lain, dan kita bisa megang kelinci yg lucu-lucu 😍😍",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjWmzNj3XCJPzdUSXJKadFaW-qLUS68nRszej3oEXAOlhsg7889-=w36-h36-p-rp-mo-br100",
  },
  {
    id: 5,
    name: "Krisela Anggun",
    rating: 5,
    time: "4 bulan lalu",
    quote:
      "Tempatnya bagus untuk edukasi anak, bersih, kelincinya juga jinak. Besssttt!",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjXh0lEUvl_DZybIJn8--mP1INCfMvy7ubaosyskNZN5YLz1A8Ri=w36-h36-p-rp-mo-ba2-br100",
  },
  {
    id: 6,
    name: "Lilly Casandra",
    rating: 5,
    time: "4 bulan lalu",
    quote:
      "Asriii & instagramable banget.. jam 2 enak sepii tapi ngga terlalu panas.",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjUgh0LDmIoS9PZjbp8Cf1Yuxe5_Zl3wUTgf3XSO9kF1T4kdjJiQ=w36-h36-p-rp-mo-ba3-br100",
  },
];

export const Testimonials: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"giz" | "riw">("giz");

  const reviews = activeTab === "giz" ? GIZ_REVIEWS : RIW_REVIEWS;

  return (
    <section
      className="py-16 bg-white border-t border-gray-100"
      id="testimonials"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-amber-50 text-amber-700 px-4 py-2 rounded-full text-sm font-bold mb-4">
            <Star className="w-4 h-4 fill-amber-400 text-amber-400" />
            Review dari Google Maps
          </div>
          <h2 className="text-3xl font-bold text-gray-900">
            Apa Kata Pengunjung?
          </h2>
          <p className="text-gray-500 mt-2">
            Pengalaman seru keluarga Indonesia di GIZ & RIW
          </p>
        </div>

        {/* Tab Switcher */}
        <div className="flex justify-center mb-10">
          <div className="inline-flex bg-gray-100 p-1.5 rounded-2xl">
            <button
              onClick={() => setActiveTab("giz")}
              className={`px-6 py-3 rounded-xl text-sm font-bold transition-all ${
                activeTab === "giz"
                  ? "bg-white text-gray-900 shadow-md"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              <span className="flex items-center gap-2">
                <span className="text-lg">🌟</span>
                GIZ Park
              </span>
            </button>
            <button
              onClick={() => setActiveTab("riw")}
              className={`px-6 py-3 rounded-xl text-sm font-bold transition-all ${
                activeTab === "riw"
                  ? "bg-white text-gray-900 shadow-md"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              <span className="flex items-center gap-2">
                <span className="text-lg">🐰</span>
                RIW
              </span>
            </button>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((item) => (
            <div
              key={item.id}
              className="bg-gray-50 p-6 rounded-2xl relative hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group"
            >
              <Quote className="absolute top-6 right-6 text-gray-200 w-8 h-8 transform rotate-180 group-hover:text-giz-primary/20 transition-colors" />

              <div className="flex items-center gap-4 mb-4">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-12 h-12 rounded-full border-2 border-white shadow-sm"
                  loading="lazy"
                  referrerPolicy="no-referrer"
                />
                <div>
                  <h4 className="font-bold text-gray-900">{item.name}</h4>
                  <p className="text-xs text-gray-500">{item.time}</p>
                </div>
              </div>

              <div className="flex mb-3">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`w-4 h-4 ${
                      i < item.rating
                        ? "text-amber-400 fill-amber-400"
                        : "text-gray-300"
                    }`}
                  />
                ))}
              </div>

              <p className="text-gray-700 text-sm leading-relaxed">
                "{item.quote}"
              </p>

              <div className="mt-4 pt-4 border-t border-gray-100">
                <div className="flex items-center gap-1 text-xs text-gray-400">
                  <MapPin className="w-3 h-3" />
                  <span>Review di Google Maps</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-sm text-gray-500">
            Sudah berkunjung? Bagikan momen seru Anda di Instagram dan tag{" "}
            <span className="font-bold text-giz-primary">@giz.park</span> dan{" "}
            <span className="font-bold text-giz-primary">
              @rabbitswonderlandsby
            </span>
          </p>
        </div>
      </div>
    </section>
  );
};
